import { useTranslation } from 'react-i18next'
import { Mail, FileText, BookOpen } from 'lucide-react'
import CampaignList from './CampaignList'
import TemplateList from './TemplateList'
import UserGuide from './UserGuide'

export const useTabs = () => {
    const { t } = useTranslation()

    return [
        {
            label: t('mailerCampaign:mailer_campaigns'),
            value: 'campaigns',
            startIcon: <Mail size={18} className="text-blue-600" />,
            component: <CampaignList />,
        },
        {
            label: t('mailerCampaign:mailer_templates'),
            value: 'templates',
            startIcon: <FileText size={18} className="text-purple-600" />,
            component: <TemplateList />,
        },
        {
            label: t('mailerCampaign:user_guide'),
            value: 'guide',
            startIcon: <BookOpen size={18} className="text-green-600" />,
            component: <UserGuide />,
        },
    ]
}
